import { Button, Dialog, DialogContent } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { CloseButton } from "../../components/CloseButton";
import { usePageScrollLock } from "../../hooks/usePageScrollLock";
import type { Tip } from "../../lib/api/tips";

function TipAction({ tip }: { tip: Tip }) {
  if (tip.detailed_html) return null;
  if (!tip.button_label || !tip.button_url) return null;
  return tip.button_url.startsWith("/") ? (
    <Button
      className="overview-secondary-action"
      component={Link}
      to={tip.button_url}
    >
      {tip.button_label}
    </Button>
  ) : (
    <Button
      className="overview-secondary-action"
      component="a"
      href={tip.button_url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {tip.button_label}
    </Button>
  );
}

export function TipContent({
  tip,
  onDetailsOpenChange,
}: {
  tip: Tip;
  onDetailsOpenChange?: (open: boolean) => void;
}) {
  const [detailsOpen, setDetailsOpen] = useState(false);
  usePageScrollLock(detailsOpen);
  const setDetailsVisibility = (open: boolean) => {
    setDetailsOpen(open);
    onDetailsOpenChange?.(open);
  };
  return (
    <>
      <div key={tip.id} className="tips-carousel-copy">
        <strong>{tip.title}</strong>
        <div
          className="tip-rich-content"
          dangerouslySetInnerHTML={{ __html: tip.short_html }}
        />
        {tip.detailed_html ? (
          <Button
            className="overview-secondary-action"
            type="button"
            onClick={() => setDetailsVisibility(true)}
          >
            Read more
          </Button>
        ) : (
          <TipAction tip={tip} />
        )}
      </div>
      <Dialog
        className="tip-details-dialog"
        open={detailsOpen}
        disableScrollLock
        fullWidth
        maxWidth="sm"
        onClose={() => setDetailsVisibility(false)}
      >
        <div className="tip-details-header">
          <h2>{tip.title}</h2>
          <CloseButton
            ariaLabel="Close tip details"
            onClick={() => setDetailsVisibility(false)}
          />
        </div>
        <DialogContent>
          <div
            className="tip-rich-content"
            dangerouslySetInnerHTML={{ __html: tip.detailed_html || "" }}
          />
          {tip.button_label && tip.button_url ? (
            <TipAction tip={{ ...tip, detailed_html: null }} />
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
